var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountSpecialities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3254 38.1284V41.2118",
    stroke: "#004171",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7422 38.1284V41.2118",
    stroke: "#004171",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3254 38.1284V41.2118",
    stroke: "#004171",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7422 38.1284V41.2118",
    stroke: "#004171",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0716 39.2107C57.8835 16.687 52.5216 6.61987 37.034 6.61987C21.5464 6.61987 16.1753 16.69 15.9995 39.2261",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7549 46.9038C59.1506 48.6366 62.16 46.577 62.16 43.3426C62.2125 42.7902 62.1431 42.2331 61.9567 41.7105C61.7703 41.188 61.4714 40.7127 61.0811 40.3183C60.6909 39.924 60.2188 39.6201 59.6982 39.4282C59.1776 39.2363 58.6212 39.1611 58.0684 39.2078",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0437 50.7855C21.5186 60.7169 28.7151 67.38 37.034 67.38C45.3528 67.38 52.5462 60.7139 56.0211 50.7855",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0148 39.1583C15.4556 39.0957 14.8895 39.159 14.358 39.3435C13.8264 39.528 13.3428 39.829 12.9426 40.2245C12.5424 40.6199 12.2356 41.0999 12.0448 41.6293C11.8541 42.1586 11.7841 42.7239 11.84 43.2838C11.84 46.4966 14.8308 48.5933 17.245 46.8481",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5339 50.616L30.5959 45.8122C32.6254 44.9576 34.7984 44.4952 37 44.4493H37.0771C39.2766 44.496 41.4474 44.9584 43.475 45.8122L55.5401 50.616",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6441 29.7944C25.6826 30.2399 22.7694 30.9625 19.943 31.9528L16.1782 33.4174",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9143 33.8948C53.9906 31.8849 49.7775 30.4993 45.4268 29.7878",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0339 35.1993C42.1426 35.1993 46.2839 31.058 46.2839 25.9493C46.2839 20.8407 42.1426 16.6993 37.0339 16.6993C31.9253 16.6993 27.7839 20.8407 27.7839 25.9493C27.7839 31.058 31.9253 35.1993 37.0339 35.1993Z",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountSpecialities);
export default __webpack_public_path__ + "static/media/count_specialities.562793f46eedd92f3ee8c2fd98a78dbe.svg";
export { ForwardRef as ReactComponent };